<template>
  <div class="shop">
    <div class="top">
      <el-date-picker
        v-model="form.start_time"
        type="date"
        class="picker"
        style="width:142px"
        value-format="yyyy-MM-dd"
        size="small"
        placeholder="选择开始时间"
      ></el-date-picker>
      <span class="guodu">~</span>
      <el-date-picker
        v-model="form.end_time"
        class="picker"
        type="date"
        style="width:142px"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="选择结束时间"
      >
      </el-date-picker>
      <el-input
        class="search input"
        size="small"
        v-model="form.user_mobile"
        placeholder="下单人手机号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.shop_mobile"
        placeholder="店主手机号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.order_sn"
        placeholder="订单编号"
        clearable
      ></el-input>
      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchOrderData"
        >搜索</el-button
      >
      <el-button size="small" type="primary" @click="exportPrivateOrder"
        >导出数据</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
      v-loading="loading"
    >
      <el-table-column label="订单编号" prop="order_sn"></el-table-column>
      <el-table-column label="下单时间" prop="created_at"></el-table-column>
      <el-table-column label="店铺手机号" prop="store_mobile"></el-table-column>
      <el-table-column label="商品名称" prop="goods_name"></el-table-column>
      <el-table-column label="订单金额" prop="total_fee"></el-table-column>
      <el-table-column label="订单状态" prop="order_status_name"></el-table-column>
      <el-table-column label="支付方式" prop="pay_type"></el-table-column>
      <el-table-column label="下单人电话" prop="user_mobile"></el-table-column>
      <el-table-column label="获取红包数" prop="money_tlj"></el-table-column>
      <el-table-column
        label="完成时间"
        prop="receive_time_order"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.order_status === 0"
            size="mini"
            type="primary"
            @click="closeOrder(scope.row.id)"
            >关闭订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--关闭订单备注-->
    <jdialog
      title="关闭订单备注"
      :visible.sync="isCloseOrderremark"
      width="640px"
    >
      <div class="remark">
        <p class="note">
          提示：关闭订单后，资金会原路返还给用户，请确认无误后操作
        </p>
        <el-form
          :model="closeform"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="输入密码：" prop="password">
            <el-input
              size="mini"
              v-model="closeform.password"
              type="password"
              style="width:120px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作备注：" prop="mark">
            <el-input
              size="mini"
              v-model="closeform.mark"
              placeholder="请输入操作备注"
              type="textarea"
              row="4"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-info">
          <el-button size="mini" @click="isCloseOrderremark = false"
            >取消</el-button
          >
          <el-button size="mini" type="primary" @click="centerorderInfo"
            >确定</el-button
          >
        </div>
      </div>
    </jdialog>
  </div>
</template>

<script>
import { selfOrder, closeOrder } from '@/api/autarky'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      isShowOrderremark: false,
      total: 0,
      form: {
        user_mobile: '',
        shop_mobile: '',
        order_sn: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 20,
        is_export: '',
        filename: ''
      },
      closeform: {
        id: '',
        mark: '',
        password: ''
      },
      remarkform: {
        order_id: '',
        remarks: ''
      },
      activities: [],
      isCloseOrderremark: false,
      rules: {
        mark: [{ required: true, message: '请输入操作备注', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    centerorderInfo() {
      if (!this.closeform.password) {
        this.$message.error('请填写密码')
        return
      }
      if (!this.closeform.mark) {
        this.$message.error('请填写备注')
        return
      }
      this.getcloseOrderUpdateData()
    },
    //关闭订单
    closeOrder(id) {
      this.closeform.id = id
      console.log(this.closeform)
      this.isCloseOrderremark = true
    },
    //关闭订单接口
    async getcloseOrderUpdateData() {
      let res = await closeOrder(this.closeform)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.getListData()
        ;(this.closeform = {
          order_id: '',
          mark: '',
          password: ''
        }),
          (this.isCloseOrderremark = false)
      } else {
        this.$message.error(res.message)
      }
    },
    //导出数据
    exportPrivateOrder() {
      this.form.is_export = 1
      this.getListData()
    },
    //搜索
    searchOrderData() {
      this.getListData()
    },
    //获取列表数据
    async getListData() {
      let url = `page=${this.form.page}&user_mobile=${this.form.user_mobile}&shop_mobile=${this.form.shop_mobile}&order_sn=${this.form.order_sn}&start_time=${this.form.start_time}&end_time=${this.form.end_time}&is_export=${this.form.is_export}&filename=${this.form.filename}`
      let res = await selfOrder(url)
      if (res.code === 10000) {
        if (this.form.is_export == 1) {
          this.form.is_export = 0
          this.loading = true
          this.exportOut(res.data.page, res.data.filename)
          // window.open(
          //   `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          // )
          this.loading = true
          return
        } else {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      } else {
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    async exportOut(page, filename) {
      let url = `page=${page}&user_mobile=${this.form.user_mobile}&shop_mobile=${this.form.shop_mobile}&order_sn=${this.form.order_sn}&start_time=${this.form.start_time}&end_time=${this.form.end_time}&is_export=1&filename=${filename}`
      let res = await selfOrder(url)
      if (res.code === 10000) {
        if (res.data.code === 2) {
          this.exportOut(res.data.page, res.data.filename)
        } else if (res.data.code === 1) {
          this.loading = false
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
          )
        } else {
          this.loading = false
          this.$message.error(res.data.message)
        }
      } else {
        this.loading = false
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getListData()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 20px;
    .search {
      margin-left: 12px;
    }
    .input {
      width: 130px;
    }
    .guodu {
      line-height: 30px;
    }
  }
  .pagination {
    margin-top: 12px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
    }
    .btn-info {
      text-align: center;
    }
  }
}
</style>
